module.exports = __webpack_public_path__ + "img/mobile2.c6189138.png";